const state = {
  // all follows of a provider on doxo. If it's zero the TrendTile along with the chart is hidden. (DOHA-1324)
  initialTotal: null,
  useGeoFilter: false
}

const mutations = {
  SET_INITIAL_TOTAL (state, initialTotal) {
    state.initialTotal = initialTotal
  },
  SET_USE_GEO_FILTER (state, value) {
    state.useGeoFilter = value
  }
}

const actions = {
  setInitialTotal ({commit}, initialTotal) {
    commit('SET_INITIAL_TOTAL', initialTotal)
  },
  setUseGeoFilter ({commit}, value) {
    commit('SET_USE_GEO_FILTER', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/providerStats/index.js